import React from 'react';
import Iffy from "../../util/Iffy/Iffy";
import DNABox from "../DNABox/DNABox";
import DNAText from "../../type/DNAText/DNAText";
import DNACard from "../DNACard/DNACard";
import DNADivider from "../../visual/DNADivider/DNADivider";
import DNAButton from "../../controls/DNAButton/DNAButton";
// TODO: These styles should be dynamically set via a config prop when the modal is instantiated. E.g. if fullscreen then no padding, etc.
const S = {
    sectionPaddingHorizontal: {
        paddingHorizontal: 16,
    },
    sectionPaddingVertical: {
        paddingVertical: 16,
    },
    sectionPaddingBottom: {
        paddingBottom: 12,
    },
    sectionPaddingTop: {
        paddingTop: 12,
    },
};
export const DNAModal = (props) => {
    const { children, style, childFill, } = props;
    return (<DNACard appearance="float" style={style || S.sectionPaddingVertical}>
      <DNABox appearance="col" fill spacing={style ? undefined : 'md'} childFill={childFill}>
        {children}
      </DNABox>
    </DNACard>);
};
export const DNAModalHeader = (props) => {
    const { onClose, style, disabled, children } = props;
    const headerContent = typeof children === 'string'
        ? <DNAText testID="dialog-title" h5>{children}</DNAText>
        : children;
    return (<>
      <DNABox testID="modal-header-container" spacing="between" alignY="center" style={style || ([S.sectionPaddingHorizontal, S.sectionPaddingBottom])}>
        {headerContent}
        <Iffy is={onClose}>
          <DNAButton disabled={disabled} appearance="ghost" status="gray" padding="sm" iconLeft="close" onPress={onClose}/>
        </Iffy>
      </DNABox>
      <DNADivider />
    </>);
};
const DNAModalMessage = (props) => {
    const { children, style, status } = props;
    return (<DNABox style={style || S.sectionPaddingHorizontal} fill>
      {/* For simple confirmation modal, arbitrary (small) width */}
      <DNAText status={status}>
        {children}
      </DNAText>
    </DNABox>);
};
const DNAModalBody = (props) => {
    const { children, style } = props;
    return (<DNABox style={style || S.sectionPaddingHorizontal} fill testID="modal-body">
      {children}
    </DNABox>);
};
const DNAModalFooter = (props) => {
    const { children } = props;
    return (<>
      <DNADivider />
      <DNABox style={[S.sectionPaddingHorizontal, S.sectionPaddingTop, { width: '100%' }]}>
        {children}
      </DNABox>
    </>);
};
const DNAModalConfirmation = (props) => {
    const { children, onCancel, onAction, actionStatus, actionLabel, style, bodyless } = props;
    return (<>
      {bodyless ? null : <DNADivider />}
      <DNABox style={style || ([S.sectionPaddingHorizontal, !bodyless && S.sectionPaddingTop])} alignX="end" spacing="md">
        <Iffy is={onCancel}>
          <DNAButton testID="cancel-button" appearance="outline" size="sm" status="tertiary" onPress={onCancel}>
            Cancel
          </DNAButton>
        </Iffy>
        <Iffy is={onAction}>
          <DNAButton testID="confirmation-button" size="sm" status={actionStatus ?? 'danger'} 
    // [TODO] Consider supporting async actions and render a spinner in the button
    onPress={onAction}>
            {actionLabel}
          </DNAButton>
        </Iffy>
        {children}
      </DNABox>
    </>);
};
DNAModal.displayName = 'DNAModal';
DNAModal.Header = DNAModalHeader;
DNAModal.Message = DNAModalMessage;
DNAModal.Body = DNAModalBody;
DNAModal.Confirmation = DNAModalConfirmation;
DNAModal.Footer = DNAModalFooter;
export default DNAModal;
//# sourceMappingURL=DNAModal.js.map